import { debugAnalytics, isDev } from "src/config";
import { Scalars, TalentVertical } from "src/graphql/types";
import { isTrackingDisabled, logAmplitudeEvent } from "src/utils/tracking";

export interface AnalyticsValues {
  ctaType: string;
  service: string;
  url: string;
  filterName: string;
  numberOfModels: number;
  jobValue: number;
  jobId?: string;
  jobName?: string;
  vertical: TalentVertical | null;
  rating: number;
  talentId: Scalars["ID"];
  // Talent onboarding and dashboard events (KTD10): meaning travels in
  // properties, not in event names.
  entryPoint: string;
  photoCount: number;
  cap: number | null;
  tierFlags: string;
  item: string;
  slotsRemaining: number;
}

export const sendToAmplitude = (event: string, properties?: unknown) => {
  if (isTrackingDisabled()) {
    return;
  }

  if (isDev && debugAnalytics) {
    console.log("[Amplitude event]", event, properties);
  }
  logAmplitudeEvent(event, properties);
};

const sendToGTM = (event: string, values?: Partial<AnalyticsValues>) => {
  if (!window.dataLayer) {
    return;
  }

  window.dataLayer.push({ event, ...values });
};

export const trackEvent = (name: string, values?: Partial<AnalyticsValues>) => {
  if (isTrackingDisabled()) {
    return;
  }

  if (isDev) {
    console.log("[Tracked event]", name, "values:", values);
  }

  sendToGTM(name, values);
};
